import * as Actions from '../actions'

const initialState = JSON.parse(window.localStorage.getItem('user')) || {
  role: 'user',
  data: {
    'displayName': '',
    'photoURL': 'assets/images/avatars/user.png',
    'email': '',
    'permissions': {}
  }
}

const user = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SET_USER_DATA: {
      return {
        ...initialState,
        ...action.payload
      }
    }
    case Actions.REMOVE_USER_DATA: {
      return {
        ...initialState
      }
    }
    case Actions.USER_LOGGED_OUT: {
      return initialState
    }
    default: {
      return state
    }
  }
}

export default user
